import { type CommonImporterError } from '../components/ImporterErrorStage/CommonImporterErrorStage'
import { type ImporterFieldNameMap } from '../types'

export interface ErrorField {
  message: string
  code: string
  value: string
}

export interface ErrorRow {
  errors_with_codes?: {
    [key: string]: ErrorField
  }
  errors?: {
    [key: string]: string
  }
  data?: { csv_line_number: number }
}

export interface ErrorRows {
  [key: string]: ErrorRow
}

export const formatErrorsByErrorCode = (
  errorRows: ErrorRows[],
  fieldNameMapper: ImporterFieldNameMap
): CommonImporterError[][] => {
  const errorGroups = {}

  errorRows.forEach((errorRow: ErrorRow) => {
    if (!errorRow.errors_with_codes) return

    Object.keys(errorRow.errors_with_codes).forEach((errorField) => {
      const {
        message = '',
        code: errorCode = '',
        value = '',
      } = errorRow.errors_with_codes[errorField] || {}

      const fieldError: CommonImporterError = {
        message,
        errorCode,
        value,
        field: fieldNameMapper?.[errorField]
          ? fieldNameMapper[errorField]
          : errorField,
        csvLineIndex: errorRow.data.csv_line_number,
        errorKey: `${errorRow.data.csv_line_number}__${errorField}`,
      }

      // group errors by error code and field column
      const groupKey = `${errorCode}_${errorField}`
      if (errorGroups[groupKey] && Array.isArray(errorGroups[groupKey])) {
        errorGroups[groupKey].push(fieldError)
      } else {
        errorGroups[groupKey] = [fieldError]
      }
    })
  })

  return Object.values(errorGroups)
}

export default formatErrorsByErrorCode
